export enum PageSectionFace {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  THIRD = 'third'
}
